import { render } from "./HeadlineBadge.vue?vue&type=template&id=503ff474&scoped=true"
import script from "./HeadlineBadge.vue?vue&type=script&lang=js"
export * from "./HeadlineBadge.vue?vue&type=script&lang=js"

import "./HeadlineBadge.vue?vue&type=style&index=0&id=503ff474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503ff474"]])

export default __exports__